import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import TrackYourShippingPage from '@/v2/components/pages/public-pages/track-your-shipping-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/track-your-shipping-page'

interface TrackYourShippingPageProps {}

const Page: React.FC<TrackYourShippingPageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.track_your_shipping.title ?? ''}
        keywords={META_CONTENTS.track_your_shipping?.keywords ?? ''}
        description={META_CONTENTS.track_your_shipping?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <TrackYourShippingPage />
    </>
  )
}

export default Page
